<template>
    <b-card class="diagnostic-header mb-4">
        <div class="header-content">
            <div class="flex-grow-1">
                <div class="d-flex align-items-center mb-3">
                    <b-button
                        variant="link"
                        class="p-0 mr-2"
                        @click="$emit('back')"
                    >
                        <i class="fa fa-arrow-left fa-lg"></i>
                    </b-button>
                    <h3 class="mb-0 header-title">
                        <i class="fa fa-clipboard-check text-primary mr-2 d-none d-md-inline"></i>
                        Detalle del Diagnóstico
                    </h3>
                </div>

                <b-row>
                    <b-col cols="12" md="6">
                        <div class="info-item">
                            <strong>Lista de chequeo:</strong>
                            <span>{{ diagnostic.check_list_company.check_list.name }}</span>
                        </div>
                        <div class="info-item">
                            <strong>Ubicación:</strong>
                            <span>{{ diagnostic.location.description }}</span>
                        </div>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="info-item">
                            <strong>Fecha diagnóstico:</strong>
                            <span>{{ formatDate(diagnostic.diagnostic_date) }}</span>
                        </div>
                        <div class="info-item">
                            <strong>Estado:</strong>
                            <b-badge :variant="diagnostic.is_active ? 'success' : 'danger'">
                                {{ diagnostic.is_active ? 'Activo' : 'Inactivo' }}
                            </b-badge>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <div class="actions-section d-flex flex-column align-items-center">
                <b-button
                    variant="info"
                    size="sm"
                    @click="$emit('show-documents')"
                    class="mb-3 documents-btn"
                >
                    <i class="fa fa-file-text mr-1"></i>
                    <span class="d-none d-sm-inline">Ver Documentos</span>
                </b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
import moment from "moment";

export default {
    name: "DiagnosticHeader",
    props: {
        diagnostic: {
            type: Object,
            required: true,
        }
    },
    methods: {
        formatDate(date) {
            return date ? moment(date).format("DD/MM/YYYY") : "-";
        },
    },
};
</script>

<style scoped>
.diagnostic-header {
    border-left: 4px solid #23a8d9;
}

/* Reducir padding del card */
.diagnostic-header >>> .card-body {
    padding: 0.75rem 1rem;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
}

.header-title {
    font-size: 1.5rem;
}

.actions-section {
    min-width: 140px;
    gap: 0;
}

.documents-btn {
    min-width: 140px;
    white-space: nowrap;
}

.info-item {
    margin-bottom: 8px;
}

.info-item strong {
    display: inline-block;
    min-width: 150px;
    color: #495057;
}

.summary-badge {
    min-width: 120px;
}

.summary-badge small {
    text-align: center;
    display: block;
}

@media (max-width: 768px) {
    .header-title {
        font-size: 1.2rem;
    }
    
    .header-content {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .actions-section {
        margin-top: 20px;
        width: 100%;
        align-items: center !important;
    }
    
    .documents-btn {
        width: auto;
    }
}

@media (max-width: 576px) {
    .documents-btn span {
        display: inline !important;
    }
}
</style>
